import { XClose } from "@untitled-ui/icons-react";
import classNames from "classnames";
import { type ReactNode } from "react";

import Button from "../forms/Button";

type NotificationProps = {
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
  onClose?: () => void;
} & Omit<React.HTMLAttributes<HTMLDivElement>, "title">;

export default function Notification({
  title,
  children,
  onClose,
  icon,
  color = "primary",
  className,
  ...rest
}: NotificationProps) {
  return (
    <div
      className={classNames(
        "rounded-xl border border-gray-200 text-gray-700 shadow-lg",
        className,
      )}
      {...rest}
    >
      <div className="relative flex items-center justify-between gap-3">
        {onClose && (
          <div className="absolute end-4 top-4">
            <Button
              size="sm"
              color="link-gray"
              onClick={() => {
                onClose();
              }}
            >
              <span className="sr-only">Close</span>
              <XClose className="size-5 text-gray-500" />
            </Button>
          </div>
        )}
        <div className="flex gap-4 p-4">
          {icon && <div>{icon}</div>}
          <div>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-1">
                {title && <div className="text-sm font-semibold">{title}</div>}
                {children && (
                  <div className="text-sm text-gray-600">{children}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
